import { render, staticRenderFns } from "./WsRequestExamsChooseGroup.vue?vue&type=template&id=23ac52dc&scoped=true"
import script from "./WsRequestExamsChooseGroup.vue?vue&type=script&lang=js"
export * from "./WsRequestExamsChooseGroup.vue?vue&type=script&lang=js"
import style0 from "./WsRequestExamsChooseGroup.vue?vue&type=style&index=0&id=23ac52dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac52dc",
  null
  
)

export default component.exports